var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, Watch, PropertyConverters, ViewChild, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.Plus {
let PacemSearchElement = class PacemSearchElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this.hintParameter = 'q';
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'hint') {
            let params = {};
            params[this.hintParameter] = val;
            this._fetcher.parameters = params;
        }
    }
};
__decorate([
    ViewChild(P + '-fetch')
], PacemSearchElement.prototype, "_fetcher", void 0);
__decorate([
    Watch()
], PacemSearchElement.prototype, "datasource", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSearchElement.prototype, "hint", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSearchElement.prototype, "url", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSearchElement.prototype, "method", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemSearchElement.prototype, "hintParameter", void 0);
PacemSearchElement = __decorate([
    CustomElement({
        tagName: P + '-search', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-fetch debounce="800" url="{{ :host.url }}" method="{{ :host.method }}">
</${P}-fetch><${P}-input-search value="{{ :host.hint, twoway }}"></${P}-input-search>
<${P}-repeater datasource="{{ ::_fetch.result }}">
    <${P}-content></${P}-content>
</${P}-repeater>`
    })
], PacemSearchElement);
export { PacemSearchElement };
